var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"spreadsheet",staticStyle:{"overflow-x":"auto","width":"100%"},attrs:{"id":"spreadsheet"}})}
var staticRenderFns = []

export { render, staticRenderFns }